"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoizedString = void 0;
class MemoizedString {
    get val() {
        return this._val;
    }
    set val(b) {
        if (this._val === b)
            return;
        this._val = b;
        this.onChangeCallback();
    }
    constructor(initialValue, onChangeCallback) {
        this._val = initialValue;
        this.onChangeCallback = onChangeCallback;
    }
}
exports.MemoizedString = MemoizedString;
